import { css } from "styled-components";
import { spaceMixin } from "../spaceMixin";
/** @class PropertyCardPhotoHeaderMixin */

/** @method */

export var PropertyCardPhotoHeaderMixin = function PropertyCardPhotoHeaderMixin(props) {
  return css(["grid-area:photo-top;padding:", ";z-index:1;display:grid;grid-auto-flow:column;grid-gap:", ";justify-content:start;"], spaceMixin("xs")(props), spaceMixin(0.5)(props));
};